import "@fontsource/libre-barcode-39"
import "@fontsource/ibm-plex-mono/400.css"
import "@fontsource/ibm-plex-mono/500.css"
import "@fontsource/ibm-plex-mono/600.css"
import "@fontsource/ibm-plex-mono/400-italic.css"
import "@fontsource/ibm-plex-mono/500-italic.css"
import "@fontsource/ibm-plex-mono/600-italic.css"
import "$styles/index.css"

import "./toggle-menu"
import "./tinyruby"
import "./gallery"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// Import all images from frontend/images
import images from "../images/**/*.{jpg,jpeg,png,svg,gif,ico,webp,jxl}"
Object.entries(images).forEach((image) => image)

console.info("Bridgetown is loaded!")
